(function () {
  let resizeTimer;

  const destroyTicker = (tickerElement) => {
    const tickerId = tickerElement.dataset.tickerId;
    const sliderElement = document.querySelector(
      `.ticker-js-${tickerId}`
    );

    if (
      sliderElement &&
      sliderElement.swiper &&
      !sliderElement.swiper.destroyed
    ) {
      sliderElement.swiper.destroy(true, true);
    }

    tickerElement.classList.remove("slider_started");
  };

  const initializeTicker = (tickerElement) => {
    if (!tickerElement) {
      return;
    }

    const tickerId = tickerElement.dataset.tickerId;
    const sliderElement = document.querySelector(
      `.ticker-js-${tickerId}`
    );

    if (!sliderElement) {
      return;
    }

    /*
     * Slider પહેલેથી ચાલતું હોય તો ફરી initialize ન કરવું.
     */
    if (
      sliderElement.swiper &&
      !sliderElement.swiper.destroyed
    ) {
      tickerElement.classList.add("slider_started");
      return;
    }

    const realSlides = sliderElement.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)"
    );

    if (realSlides.length === 0) {
      return;
    }

    const rawSpeed = Number(tickerElement.dataset.tickerSpeed);

    const tickerSpeed =
      Number.isFinite(rawSpeed) && rawSpeed > 0
        ? rawSpeed * 1000
        : 8000;

    const shouldAnimate = realSlides.length > 1;

    tickerElement.classList.add("slider_started");

    new Swiper(sliderElement, {
      slidesPerView: "auto",
      speed: tickerSpeed,
      initialSlide: 0,

      /*
       * Real slides એકથી વધારે હોય ત્યારે જ loop બનાવવો.
       */
      loop: shouldAnimate,

      /*
       * જૂનું loopedSlides: 50 દૂર કર્યું.
       * Extra duplicate slides બનાવવાના નથી.
       */
      loopAdditionalSlides: 0,

      allowTouchMove: false,
      waitForTransition: false,
      watchSlidesProgress: false,
      watchOverflow: true,

      autoplay: shouldAnimate
        ? {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          }
        : false
    });
  };

  const tickSlider = () => {
    document.querySelectorAll(".ticker").forEach(
      (tickerElement) => {
        initializeTicker(tickerElement);
      }
    );
  };

  /*
   * Initial load.
   */
  tickSlider();

  /*
   * Shopify Theme Editorમાં section reload થાય ત્યારે.
   */
  document.addEventListener(
    "shopify:section:load",
    function () {
      window.setTimeout(tickSlider, 100);
    }
  );

  /*
   * Resizeને debounce કરીને unnecessary repeated work અટકાવ્યું.
   */
  window.addEventListener("resize", function () {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll(".ticker").forEach(
        (tickerElement) => {
          const tickerId = tickerElement.dataset.tickerId;
          const sliderElement = document.querySelector(
            `.ticker-js-${tickerId}`
          );

          if (
            sliderElement &&
            sliderElement.swiper &&
            !sliderElement.swiper.destroyed
          ) {
            sliderElement.swiper.update();
          }
        }
      );
    }, 150);
  });

  /*
   * Tab hidden હોય ત્યારે autoplay stop કરવો.
   * પાછું open થાય ત્યારે existing slider resume કરવું.
   * પહેલાં જેવું destroy/recreate નહીં થાય.
   */
  document.addEventListener(
    "visibilitychange",
    function () {
      document.querySelectorAll(".ticker-js").forEach(
        (sliderElement) => {
          const swiper = sliderElement.swiper;

          if (
            !swiper ||
            swiper.destroyed ||
            !swiper.autoplay
          ) {
            return;
          }

          if (document.hidden) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.start();
          }
        }
      );
    }
  );

  /*
   * Theme editor section unload થાય ત્યારે cleanup.
   */
  document.addEventListener(
    "shopify:section:unload",
    function (event) {
      const section = event.target;

      if (!section) {
        return;
      }

      section.querySelectorAll(".ticker").forEach(
        (tickerElement) => {
          destroyTicker(tickerElement);
        }
      );
    }
  );
})();

// (function () {
//   const tickSlider = () => {
// 		$(".ticker").each(function(){
// 			if ($(this).hasClass('slider_started')){
// 				return ''
// 			}
// 			$(this).addClass('slider_started');
// 			const tickerId = $(this).data('ticker-id');
// 			const tickerSpeed = $(this).data('ticker-speed') * 1000;
// 			const tickerSwiper = new Swiper(`.ticker-js-${tickerId}`, {
// 				slidesPerView: "auto",
// 				speed: tickerSpeed,
// 				initialSlide: 0,
// 				loop: true,
// 				loopedSlides: 50,
// 				allowTouchMove: false,
// 				waitForTransition: false,
// 				watchSlidesProgress: false,
// 				autoplay: {
// 					delay: 0,
// 					disableOnInteraction: false,
// 				},
// 			});
// 		})
//   };

//   tickSlider();
//   document.addEventListener("shopify:section:load", function () {
//     setTimeout(() => {
//       tickSlider();
//     }, 100);
//   });

//   document.addEventListener("visibilitychange", function () {
//     if (!document.hidden) {
//       $(".ticker-js").each(function () {
//         this.swiper.destroy();
//       });
//       tickSlider();
//     }
//   });

//   setTimeout(() => {
//     tickSlider();
//   }, 100);
// })();
